// Klasser som motsvarar diton i C#:




/*


 Obs! Dessa måste överensstämma *exakt* med resultatet av en konvertering av motsvarande C#-klasser till Json!!!
 Bl.a. att de har inledande versaler på proparna (C# naming convention).






*/


const defaultForslag = `
<ul>
	<li>Använd några olika ord och undvik vanliga fraser.</li>
	<li>Om du väljer ett lite längre lösen behöver du inte använda siffror, symboler eller blanda stora och små bokstäver.</li>
	<li style="list-style-type: none;">Exempel: '<b>bubbla fisk mjälte</b>' (eller&nbsp;'<b>bubblafiskmjälte</b>', utan mellanslag).</li>
</ul>`;



//###################################################################################################

class LosenStyrkaCustomDataClass
{
		//public int Styrka { get; set; }
		//public string VarningHtml { get; set; }
		//public string ForslagHtml { get; set; }

	constructor(
		// Named and optional parameters (med eventuella default satta), as options object:
		{
			styrka = undefined,

			varningHtml = undefined,
			forslagHtml = defaultForslag,
		}
		= {}	// Default för den optional options-parametern som sådan.
	)
	{
		// Först lite basic typkontroller av parametrarna: ---------------------------

		console.assert(!styrka || typeof styrka === 'number',
			'Parametern \'styrka\' måste vara av typen \'number\' (eller null/undefined).');

		console.assert(!styrka || (styrka >= 0 && styrka <= 4),
			'Parametern \'styrka\' måste, när den är satt, vara ett värde 0–4.');

		console.assert(!varningHtml || typeof varningHtml === 'string',
			'Parametern \'varningHtml\' måste vara av typen \'string\' (eller null/undefined).');

		console.assert(!forslagHtml || typeof forslagHtml === 'string',
			'Parametern \'forslagHtml\' måste vara av typen \'string\' (eller null/undefined).');

		// ---------------------------------------------------------------------------

		this.Styrka = styrka;
		this.VarningHtml = varningHtml;
		this.ForslagHtml = forslagHtml;
	}


	// Static method för att efterlikna copy constructor/cast (från ett korrekt object som dock bara inte är av typen AnvandareFormModelClass):
	static castFrom(obj)
	{
		let ny = new LosenStyrkaCustomDataClass();
		ny = Object.assign(ny, obj);

		if (!ny.ForslagHtml)
			ny.ForslagHtml = defaultForslag;

		return ny;
	}

	get StyrkaHtml() {

		// undefined och 0 hanteras olika!!
		if (this.Styrka !== undefined)
		{
			// 0 # too guessable: risky password. (guesses < 10^3)
			// 1 # very guessable: protection from throttled online attacks. (guesses < 10^6)
			// 2 # somewhat guessable: protection from unthrottled online attacks. (guesses < 10^8)
			// 3 # safely unguessable: moderate protection from offline slow-hash scenario. (guesses < 10^10)
			// 4 # very unguessable: strong protection from offline slow-hash scenario. (guesses >= 10^10)

			switch (this.Styrka)
			{
				case 0: return '<p>Mycket osäkert. Alldeles för lätt att gissa!</p>';
				case 1: return '<p>Osäkert. För lätt att gissa!</p>';
				case 2: return '<p>Ganska säkert, men <i>kan</i> gå att gissa.</p>';
				case 3: return '<p>Säkert.</p>';
				case 4: return '<p>Mycket säkert. Bra jobbat!</p>';
			}
		}

		return undefined;
	}
}


export default { LosenStyrkaCustomDataClass };

export { LosenStyrkaCustomDataClass as LosenStyrkaCustomData };

